// Import the full client (not lite) for recommend widgets
import { algoliasearch } from 'algoliasearch';

function readEnv(name, { required = true } = {}) {
  const raw = process.env[name];
  const value = typeof raw === 'string' ? raw.trim() : '';
  if (required && !value) {
    throw new Error(
      `[Algolia] Missing ${name}. Set it in .env at the project root (next to package.json), then restart the dev server.`
    );
  }
  return value || undefined;
}

export const ALGOLIA_APP_ID = readEnv('REACT_APP_ALGOLIA_APP_ID');
export const ALGOLIA_SEARCH_API_KEY = readEnv('REACT_APP_ALGOLIA_SEARCH_API_KEY');
/** Present for reference; Insights HTTP events use the search key (Algolia requires `search` ACL on that endpoint). */
export const ALGOLIA_INSIGHTS_API_KEY = readEnv('REACT_APP_ALGOLIA_INSIGHTS_API_KEY', {
  required: false,
});

export const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);

export const PRODUCT_INDEX = 'saq_products';
export const STORE_INDEX = 'saq_stores'; 